import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import { getRule } from "../../http/ruleApi";
import RuleSettings from "./RuleSettings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function RuleModal(props) {
  const [rule, setRule] = React.useState(props.rule || null);
  const [open, setOpen] = React.useState(props.open);

  const handleClose = () => {
    console.log(rule);
    setRule({ rule: { name: "" } });
    props.setOpen(false);
  };

  return (
    <>
      {rule !== null ? (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          width={800}
          my={4}
          gap={4}
          p={2}
          sx={{ border: "2px solid grey" }}
        >
          <RuleSettings
            rule={rule}
            setRule={setRule}
            setOpen={setOpen}
            setRules={props.setRules}
            rules={props.rules}
          />
        </Dialog>
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          width={800}
          my={4}
          gap={4}
          p={2}
          sx={{ border: "2px solid grey" }}
        >
          <RuleSettings
            setRule={setRule}
            setOpen={setOpen}
            setRules={props.setRules}
            rules={props.rules}
          />
        </Dialog>
      )}
    </>
  );
}
